import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

export const formatTimestamp = (timeMs) =>
  new Date(timeMs * 1000).toISOString().substr(11, 8);

export const formatTimestampforSaving = (formatedString) => {
  const time = formatedString.split(':');
  return parseInt(time[0]) * 3600 + parseInt(time[1]) * 60 + parseInt(time[2]);
};

export const formatDuration = (duration) =>
  duration
    ? moment.duration({ seconds: duration }).format('HH:mm:ss', {
        trim: false,
      })
    : 'not available';



// WEBPACK FOOTER //
// ./services/formatTimestamp.js